import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Box } from '@chakra-ui/react';
import { ROOT_CLASSNAME, ROOT_SELECTOR } from '@view/constants/root';
import { usePortal } from '@view/hooks/usePortal';
// Use this component directly to render a portal
export const Portal = forwardRef(({ appendToRoot = false, children, className = '', id, parentSelector, type, }, ref) => {
    const parent = parentSelector !== null && parentSelector !== void 0 ? parentSelector : (appendToRoot ? ROOT_SELECTOR : 'body');
    const { createPortal } = usePortal({ parent });
    // These targets are already inside `.cb-bookingengine-root`, so the children
    // go in bare: the wrapper below would insert a box the target's own layout
    // does not account for (the popup card, for one, is a flex column).
    if (appendToRoot || parentSelector) {
        return createPortal(children, id);
    }
    return createPortal(_jsx(Box, { className: ROOT_CLASSNAME, children: _jsx(Box, { className: ['cb-portal', className].filter(Boolean).join(' '), "data-testid": id, id: id, position: "relative", ref: ref, zIndex: type, children: children }) }), id);
});
